import { render, staticRenderFns } from "./BookSelect.vue?vue&type=template&id=25424ab7&scoped=true&"
import script from "./BookSelect.vue?vue&type=script&lang=js&"
export * from "./BookSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25424ab7",
  null
  
)

export default component.exports